<template>
  <div class="data-grid-composite">
    <AsyncComponent v-if="componentPath"
                    :component-path="componentPath"
                    v-bind="$attrs"
                    v-on="$listeners"></AsyncComponent>
  </div>
</template>

<script>
import AsyncComponent from '../async/AsyncComponent'
export default {
  name: 'DataGridComposite',
  components: {
    AsyncComponent
  },
  props: {
    componentPath: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss">
  .data-grid-composite {
    height: 100%;
  }
</style>
